import * as React from 'react'
import cx from 'classnames'
import styles from './ThumbsRating.sass'
import Icon from 'components/Icon'
import { FormGroupContainer } from 'components/inputs'

interface Props {
  value?: boolean
  iconSize?: number
  readOnly?: boolean
  disabled?: boolean
  error?: string
  onChange?: (value: boolean) => unknown
}

export default function ThumbsRating({
  value = undefined,
  onChange,
  iconSize,
  error,
  disabled = false,
  readOnly = false,
}: Props) {
  const createChangeHandler = (newValue: boolean) => () => {
    if (readOnly || disabled) {
      return
    }
    if (!onChange) {
      return
    }

    if (newValue !== value) {
      onChange(newValue)
    }
  }

  return (
    <FormGroupContainer error={error} className={styles.formContainer}>
      <div className={cx(styles.root)}>
        <ThumbsDown
          value={value}
          disabled={disabled}
          readOnly={readOnly}
          iconSize={iconSize}
          onClick={createChangeHandler(false)}
        ></ThumbsDown>
        <ThumbsUp
          value={value}
          disabled={disabled}
          readOnly={readOnly}
          iconSize={iconSize}
          onClick={createChangeHandler(true)}
        ></ThumbsUp>
      </div>
    </FormGroupContainer>
  )
}

interface ThumbsProps {
  value?: boolean
  disabled: boolean
  readOnly: boolean
  iconSize?: number
  onClick(): unknown
}

function ThumbsDown({
  value,
  onClick,
  iconSize,
  disabled,
  readOnly,
}: ThumbsProps) {
  const click = React.useCallback(() => onClick(), [onClick])

  return (
    <span
      className={cx(
        styles.thumbs,
        disabled && styles.disabled,
        readOnly && styles.readOnly,
        value === false && styles.thumbsDown,
      )}
      onClick={click}
      style={{ fontSize: iconSize }}
    >
      <Icon auto name="ratings-thumbs-down" />
    </span>
  )
}

function ThumbsUp({
  value,
  onClick,
  iconSize,
  disabled,
  readOnly,
}: ThumbsProps) {
  const click = React.useCallback(() => onClick(), [onClick])

  return (
    <span
      className={cx(
        styles.thumbs,
        disabled && styles.disabled,
        readOnly && styles.readOnly,
        value && styles.thumbsUp,
      )}
      onClick={click}
      style={{ fontSize: iconSize }}
    >
      <Icon auto name="ratings-thumbs-up" />
    </span>
  )
}
